module.exports = __webpack_public_path__ + "static/media/uisce.e02950ca.png";